import React from 'react';
import { Link } from 'react-router-dom';
import { stores } from '../data/mockData';
import { ArrowRight, Star } from 'lucide-react';

const StoreLogos = () => {
  const storeLogos = {
    levis: { text: "Levi's", color: '#c41230', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    wrangler: { text: 'WRANGLER', color: '#000000', bg: '#fff', font: 'font-bold text-lg md:text-xl tracking-wide' },
    lee: { text: 'Lee', color: '#000080', bg: '#fff', font: 'font-bold text-2xl md:text-3xl' },
    diesel: { text: 'DIESEL', color: '#c41230', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-wide' },
    'gstar-raw': { text: 'G-STAR RAW', color: '#000000', bg: '#fff', font: 'font-bold text-base md:text-lg tracking-wide' },
    'true-religion': { text: 'TRUE RELIGION', color: '#000000', bg: '#fff', font: 'font-bold text-sm md:text-base tracking-wider' },
    'ag-jeans': { text: 'AG', color: '#000000', bg: '#fff', font: 'font-bold text-2xl md:text-3xl', subtitle: 'JEANS', subtitleColor: '#666' },
    'citizens-of-humanity': { text: 'CITIZENS', color: '#000000', bg: '#fff', font: 'font-light text-base md:text-lg tracking-[0.2em]', subtitle: 'of Humanity' },
    'nudie-jeans': { text: 'Nudie Jeans', color: '#000000', bg: '#fff', font: 'font-medium text-lg md:text-xl' },
    madewell: { text: 'madewell', color: '#000000', bg: '#fff', font: 'font-medium text-xl md:text-2xl lowercase' },
    frame: { text: 'FRAME', color: '#000000', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-[0.15em]' },
    'rag-bone': { text: 'rag & bone', color: '#000000', bg: '#fff', font: 'font-medium text-lg md:text-xl lowercase' },
    '7-for-all-mankind': { text: '7', color: '#000000', bg: '#fff', font: 'font-bold text-3xl md:text-4xl', subtitle: 'FOR ALL MANKIND', subtitleColor: '#666' },
    'hudson-jeans': { text: 'HUDSON', color: '#000000', bg: '#fff', font: 'font-bold text-xl md:text-2xl tracking-wide' },
    paige: { text: 'PAIGE', color: '#000000', bg: '#fff', font: 'font-light text-xl md:text-2xl tracking-[0.2em]' },
    dl1961: { text: 'DL1961', color: '#000000', bg: '#fff', font: 'font-bold text-xl md:text-2xl' },
    'joes-jeans': { text: "JOE'S", color: '#000000', bg: '#fff', font: 'font-bold text-xl md:text-2xl', subtitle: 'JEANS', subtitleColor: '#666' },
    agolde: { text: 'AGOLDE', color: '#000000', bg: '#fff', font: 'font-medium text-xl md:text-2xl tracking-wide' },
  };

  const renderStoreLogo = (store) => {
    const logoInfo = storeLogos[store.slug];
    if (!logoInfo) {
      return <span className="text-lg font-bold text-slate-700">{store.name}</span>;
    }

    // Handle logos with subtitles
    if (logoInfo.subtitle) {
      return (
        <div className="flex flex-col items-center">
          <span className={`${logoInfo.font || 'text-lg md:text-xl font-bold'}`} style={{ color: logoInfo.color }}>
            {logoInfo.text}
          </span>
          <span className="text-[8px] md:text-[10px] tracking-wider" style={{ color: logoInfo.subtitleColor || '#666' }}>
            {logoInfo.subtitle}
          </span>
        </div>
      );
    }

    return (
      <span
        className={`${logoInfo.font || 'text-xl md:text-2xl font-bold'}`}
        style={{ color: logoInfo.color }}
      >
        {logoInfo.text}
      </span>
    );
  };

  const displayStores = [
    ...stores.filter(s => ['levis', 'wrangler', 'lee', 'diesel', 'gstar-raw'].includes(s.slug)),
    ...stores.filter(s => ['true-religion', 'ag-jeans', 'madewell', 'frame', 'paige'].includes(s.slug)),
  ].slice(0, 10);

  return (
    <section className="py-12 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <Star className="w-5 h-5 text-amber-500 fill-amber-500" />
              <span className="text-sm font-semibold text-amber-600 uppercase tracking-wider">Featured</span>
            </div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900">Popular Stores</h2>
          </div>
          <Link 
            to="/stores" 
            className="flex items-center gap-2 text-[#345a83] font-semibold hover:text-indigo-800 transition-colors group"
          >
            View all stores
            <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>

        {/* Store Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
          {displayStores.map((store, index) => (
            <Link
              key={store.id}
              to={`/store/${store.slug}`}
              className="group bg-white border-2 border-slate-100 rounded-2xl p-6 flex items-center justify-center min-h-[100px] md:min-h-[120px] hover:border-[#9abadd] hover:shadow-xl hover:shadow-[#c5d5e8]/50 transition-all duration-300 animate-fadeInUp opacity-0"
              style={{ animationDelay: `${index * 0.05}s`, animationFillMode: 'forwards' }}
            >
              <div className="transform group-hover:scale-110 transition-transform duration-300">
                {renderStoreLogo(store)}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StoreLogos;
